import React from 'react'
import { Link } from 'gatsby'
import _ from 'lodash'
import strftime from 'strftime'
import classnames from 'classnames'

import '../css/PostListing.scss';


export class PostListing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      keyword: ""
    }
  }

  _handleChangeSearch = (e) => {
    console.log(e.target.value)
    this.setState({keyword: e.target.value})
  }

  render() {
    const { posts } = this.props;
    const { keyword } = this.state;
    const searchRe = (_.isEmpty(keyword)) ? null : new RegExp(_.escapeRegExp(keyword))
    const nodes = _.reduce(posts, (acc, node, i) => {
      const fields = _.get(node, 'node.fields')
      const title = _.get(fields, 'title');
      if (!searchRe || searchRe.test(title)) {
        const date = new Date(_.get(fields, 'createdAt'));
        acc.push(
          <div key={`post-${i}`}>
            <span>{strftime('%Y%m%d%H%M', date)}</span>
            <Link to={_.get(fields, 'slug')}>
              <span>{title}</span>
            </Link>
          </div>
        )
      }
      return acc
    }, []);

    return (
      <div className={classnames('blog-posts')}>
        <div className={classnames('blog-posts-search')}>
          <input
            type="text"
            placeholder={"Search"}
            value={_.get(this.state, 'keyword', "")}
            onChange={this._handleChangeSearch} />
        </div>
        <div className={classnames('blog-posts-nodes')}>
          {nodes}
        </div>
      </div>
    );
  }
}

export default PostListing
